import React from 'react';
import Layout from '../../components/horticulture/layout';
import './contact.css';

export default function ContactPage() {
  return (
    <Layout>
      <h1 style={{ paddingTop: '2rem', marginBottom: '1rem' }}>Contact Us</h1>

      <section style={{ marginBottom: '1rem' }}>
        If you have any questions regarding our products or services, please
        contact us by phone or by the form below. We look forward to hearing
        from you.
      </section>
      <address style={{ marginBottom: '1rem', fontStyle: 'normal' }}>
        <strong>Benjamin Smart Power</strong> <br />
        <em>by Benjamin Electric Co.</em> <br />
        1615 Staunton Ave <br />
        Los Angeles, CA 90021-3118 <br />
        Phone: (213) 749-7731
      </address>

      <form className="contact-form" method="post" action="/contact.php">
        <label htmlFor="name">Name</label>
        <input name="name" placeholder="Type Here" required="" />

        <label htmlFor="phone">Phone</label>
        <input name="phone" placeholder="Type Here" />

        <label htmlFor="email">Email</label>
        <input name="email" type="email" placeholder="Type Here" required="" />

        <label htmlFor="subject">Subject</label>
        <input name="subject" placeholder="Type Here" required="" />

        <label htmlFor="message">Message</label>
        <textarea name="message" placeholder="Type Here" required="" />

        <label htmlFor="human">*What is 2+2? (Anti-spam)</label>
        <input name="human" placeholder="Type Here" required="" />

        <input
          name="site"
          type="hidden"
          value="benjaminsmartpower.com/horticulture"
        />

        <input
          id="submit"
          name="submit"
          type="submit"
          value="Submit"
          className="button-submit"
        />
      </form>
    </Layout>
  );
}
